import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";
import { HubButtonGroup } from "../../components";

export const StyledPageLayout = styled(Stack)({
  height: "100%",
  overflow: "hidden",
  flexDirection: "row",
});

export const StyledContent = styled(Stack)({
  flex: 1,
  height: "100%",
  overflow: "hidden",
});

export const StyledTitleStack = styled(Stack)(({ theme }) => ({
  height: "40px",
  flexDirection: "row",
  gap: "25px",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: theme.palette.hubColors.white,
  borderBottom: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
}));

export const StyledTitledSubStack = styled(Stack, {
  shouldForwardProp: (prop) => !["disableYPadding"].includes(prop),
})(({ disableYPadding }) => ({
  flexDirection: "row",
  gap: "10px",
  alignItems: "center",
  padding: disableYPadding ? "0px 15px" : "7px 15px",
  height: "100%",
}));

export const StyledHubButtonGroup = styled(HubButtonGroup)({
  marginTop: "auto",
  ".MuiButtonBase-root": {
    border: "none",
    borderRadius: 0,
    marginBottom: "1px",
    ":hover": {
      border: "none",
    },
    fontSize: "11px"
  },
  ".HubButtonGroup-selected": {
    borderBottom: "2px solid",
    marginBottom: "-1px",
    ":hover": {
      border: "none",
      borderBottom: "2px solid",
    },
  },
});
